import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Main.css';
import AOS from 'aos';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import bannerImg from '../../images/main/banner_img.png';
import mainbanner2 from '../../images/main/Main_banner_2.png';
import maininfo1 from '../../images/main/output.mp4';
import logo from '../../images/main/4S_Mapper_logo_white.png';
import logoText from '../../images/main/4S-Mapper_LOGO_LogoType.png';
import mainplatformimg1 from '../../images/main/Main_platform_img1.png';
import mainplatformimg2 from '../../images/main/Main_platform_img2.png';
import mainplatformimg3 from '../../images/main/Main_cfsm_card.mov';
import mainplatformimg4 from '../../images/main/Main_platform_img4.png';
import main_cfsm from '../../images/main/cfsm.mp4';
import main_3d from '../../images/main/Main_3d.png';
import main_hd from '../../images/main/Main_hd.png';
import main_auto from '../../images/main/Main_auto.png';
import Main_Hard_img from '../../images/main/Main_Hard_img.png';
import Main_Soft_img from '../../images/main/Main_Soft_img.png';
import SHARE_Logo from '../../images/main/Logo/SHARE_Logo.png';
import CHCNAV_Logo from '../../images/main/Logo/CHCNAV_Logo.png';
import beyless_Logo from '../../images/main/Logo/beyless_Logo.png';
import DJI_Logo from '../../images/main/Logo/DJI_Logo.png';
import FIXAR_Logo from '../../images/main/Logo/FIXAR_Logo.svg';
import Singular_Logo from '../../images/main/Logo/singular_Logo.png';
import TUNDRA_Logo from '../../images/main/Logo/TUNDRA_Logo.png';

const Main = () => {
  const { t } = useTranslation('main'); // Main namespace 사용
  const location = useLocation();
  const navigate = useNavigate();

  // 스크롤 복원 (뒤로가기 시 완벽히 동일한 위치로 복귀)
  useEffect(() => {
    const preloadImg = new Image();
    preloadImg.src = require('../../images/contact/contact_bg.png');

    const savedY = sessionStorage.getItem('mainScrollY');
    if (!savedY) return;

    // DOM + 이미지 렌더 완료 시점 체크
    const handleStableScroll = () => {
      const targetY = parseInt(savedY, 10);
      let attempts = 0;

      const check = () => {
        attempts++;
        const before = document.body.scrollHeight;

        setTimeout(() => {
          const after = document.body.scrollHeight;
          if (before === after || attempts > 50) {
            window.scrollTo({ top: targetY, behavior: 'auto' });
            if (AOS && typeof AOS.refresh === 'function') AOS.refresh();
            sessionStorage.removeItem('mainScrollY');
          } else {
            check();
          }
        }, 60);
      };

      check();
    };

    // 완전히 렌더된 이후 실행
    requestAnimationFrame(() => requestAnimationFrame(handleStableScroll));
  }, [location.key]);

  // Solution으로 이동 시 현재 스크롤 저장 + Lenis 정지
  const handleNavigate = (sectionId) => {
    sessionStorage.setItem('mainScrollY', window.scrollY);

    // 🎯 Lenis 감속 중단
    if (window.lenis && typeof window.lenis.stop === 'function') {
      window.lenis.stop();
    }

    // 🚀 즉시 페이지 이동
    navigate(`/Solution#${sectionId}`);

    // 새 페이지 로드 후 Lenis 재시작
    setTimeout(() => {
      if (window.lenis && typeof window.lenis.start === 'function') {
        window.lenis.start();
      }
    }, 400); // 0.4초 정도 후 재개 (라우트 전환 이후)
  };

  // Product로 이동 시 현재 스크롤 저장 + Lenis 정지
  const handleProductNavigate = (sectionId) => {
    sessionStorage.setItem('mainScrollY', window.scrollY);
    if (window.lenis && typeof window.lenis.stop === 'function') {
      window.lenis.stop();
    }
    navigate(`/Products#${sectionId}`);
    setTimeout(() => {
      if (window.lenis && typeof window.lenis.start === 'function') {
        window.lenis.start();
      }
    }, 400);
  };

  const logos = [
    { src: SHARE_Logo, name: 'SHARE' },
    { src: CHCNAV_Logo, name: 'CHCNAV' },
    { src: beyless_Logo, name: 'Beyless' },
    { src: DJI_Logo, name: 'DJI' },
    { src: FIXAR_Logo, name: 'FIXAR' },
    { src: Singular_Logo, name: 'SingularXYZ' },
    { src: TUNDRA_Logo, name: 'TUNDRA' },
  ];

  return (
    <>
      <Header />
      <div className="Container">
        <div className="Main_Section">
          <div data-aos="fade" data-aos-delay="500" className="main_banner">
            <div>
              <div className="banner_image_wrap">
                <img className="banner_image" src={bannerImg} alt="banner" />
                <img className="banner_image_highlight" src={bannerImg} alt="highlight" />
              </div>
              <div className="main_banner_info">
                <div
                  data-aos="fade-left"
                  data-aos-delay="1100"
                  data-aos-easing="ease-out"
                  data-aos-duration="1300"
                  className="main_banner_info_main"
                >
                  {t('mainsection.des')}
                  <div className="logo-text">
                    <img className="logoText" src={logoText} />
                    4S Mapper
                  </div>
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-delay="1300"
                  data-aos-easing="ease-out"
                  data-aos-duration="1300"
                  className="main_banner_info_sub"
                >
                  {t('mainsection.des1')}
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-delay="1300"
                  data-aos-duration="1300"
                  data-aos-easing="ease-out"
                  className="custom-btn_box"
                >
                  <NavLink
                    to="/About"
                    className={({ isActive }) => (isActive ? 'custom-btn' : 'custom-btn')}
                  >
                    {t('About')}
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-indicator">
            <div className="arrow"></div>
          </div>
        </div>
        <div className="Main_info_section">
          <div className="Main_info_section_container">
            <div
              data-aos="fade"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="section_title"
            >
              OUR CORE THING
            </div>
            <video
              autoPlay
              loop
              muted
              playsInline
              src={maininfo1}
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="Main_info_img_1"
            />
            <div className="Main_info_title">{t('mainsection.title')}</div>
            <div className="Main_info_sub">{t('mainsection.sub')}</div>
          </div>
        </div>
        <div className="Main_info_section2">
          <div className="Main_info_section2_contents">
            <div
              data-aos="fade"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="section_title"
            >
              <div>Platform</div>
            </div>
            <div
              data-aos="fade-right"
              data-aos-duration="800"
              data-aos-delay="300"
              data-aos-easing="ease-out"
              className="Main_info_section2_box"
            >
              <img className="Main_info_section2_box_img" src={mainplatformimg1} />
              <div className="Main_info_section2_info_box">
                <div className="Main_info_section2_info_box_title">
                  DaaS: <span>Drone as a Service</span>
                </div>
                <div className="Main_info_section2_info_box_sub">{t('section2.daas')}</div>
                <div>
                  <NavLink
                    to="/DaasPano"
                    className={({ isActive }) => (isActive ? 'daas_btn' : 'daas_btn')}
                  >
                    {t('DaaS Pano (360°)')}
                  </NavLink>
                </div>
                {/* <div className='Main_info_section2_info_box_more'>More 〉</div> */}
              </div>
            </div>
            <div
              data-aos="fade-right"
              data-aos-duration="800"
              data-aos-delay="400"
              data-aos-easing="ease-out"
              className="Main_info_section2_box"
            >
              <img className="Main_info_section2_box_img" src={mainplatformimg2} />
              <div className="Main_info_section2_info_box">
                <div className="Main_info_section2_info_box_title">
                  DTM: <span>Drone Traffic Mapper / Drone to Mapper</span>
                </div>
                <div className="Main_info_section2_info_box_sub">{t('section2.dtm')}</div>
                {/* <div className='Main_info_section2_info_box_more'>More 〉</div> */}
              </div>
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="800"
              data-aos-delay="500"
              data-aos-easing="ease-out"
              className="Main_info_section2_box"
            >
              <div className="Main_info_section2_info_box">
                <div className="Main_info_section2_info_box_title">
                  CfSM: <span>Car-free Street Mapping</span>
                </div>
                <div className="Main_info_section2_info_box_sub">{t('section2.cfsm')}</div>
                {/* <div className='Main_info_section2_info_box_more'>More 〉</div> */}
              </div>
              <video
                autoPlay
                loop
                muted
                playsInline
                className="Main_info_section2_box_img"
                src={mainplatformimg3}
              />
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="800"
              data-aos-delay="600"
              data-aos-easing="ease-out"
              className="Main_info_section2_box"
            >
              <div className="Main_info_section2_info_box">
                <div className="Main_info_section2_info_box_title">
                  AfGG: <span>Auto-labeling 5G Geo-spatial Information HDS Map</span>
                </div>
                <div className="Main_info_section2_info_box_sub">{t('section2.afgg')}</div>
                {/* <div className='Main_info_section2_info_box_more'>More 〉</div> */}
              </div>
              <img className="Main_info_section2_box_img" src={mainplatformimg4} />
            </div>
          </div>
          <div className="Main_info_section3">
            <div className="Main_info_section3_contents">
              <div
                data-aos="fade"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
                className="section_title"
              >
                <div>Solutions</div>
              </div>
              <div
                data-aos="fade-right"
                data-aos-delay="500"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
                className="Main_info_section3_box1"
              >
                <div className="Main_info_section3_box_content1">
                  <div className="Main_info_section3_box_title">
                    CfSM <span>(Car-free Street Mapping)</span>
                  </div>
                  {/* <div className="Main_info_section3_box_sub">{t('section3.cfsm')}</div> */}
                  <div className="Main_info_section3_box_img_box">
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      onMouseEnter={(e) => e.target.pause()}
                      onMouseLeave={(e) => e.target.play()}
                      onClick={() => handleNavigate('cfsm')}
                      className="cfsm_video"
                      src={main_cfsm}
                    />
                  </div>
                </div>
                <div className="Main_info_section3_box_content2">
                  <div className="Main_info_section3_box_title_2">3D Modeling</div>
                  {/* <div className="Main_info_section3_box_sub_2">{t('section3.3d')}</div> */}
                  <div className="Main_info_section3_box_img_box">
                    <img
                      className="Main_info_section3_box_img"
                      src={main_3d}
                      onClick={() => handleNavigate('modeling')}
                    />
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-left"
                data-aos-delay="500"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
                className="Main_info_section3_box2"
              >
                <div className="Main_info_section3_box_content2">
                  <div className="Main_info_section3_box_img_box">
                    <img
                      className="Main_info_section3_box_img"
                      src={main_hd}
                      onClick={() => handleNavigate('hd')}
                    />
                  </div>
                  <div className="Main_info_section3_box_title_d">HD Safety Map</div>
                  {/* <div className="Main_info_section3_box_sub_d">{t('section3.hd')}</div> */}
                </div>
                <div className="Main_info_section3_box_content2">
                  <div className="Main_info_section3_box_img_box">
                    <img
                      className="Main_info_section3_box_img"
                      src={main_auto}
                      onClick={() => handleNavigate('auto')}
                    />
                  </div>
                  <div className="Main_info_section3_box_title_2_d">Automatic Data Processing</div>
                  {/* <div className="Main_info_section3_box_sub_2_d">{t('section3.auto')}</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Main_info_section4">
          <div
            data-aos="fade"
            data-aos-easing="ease-out"
            data-aos-duration="1300"
            className="section_title"
          >
            <div>Products</div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="500"
            data-aos-easing="ease-out"
            data-aos-duration="1300"
            className="section4_img"
          >
            <img
              className="Main_info_section4_box_img"
              src={Main_Soft_img}
              alt="Software"
              onClick={() => handleProductNavigate('software')}
            />
            <img
              className="Main_info_section4_box_img"
              src={Main_Hard_img}
              alt="Hardware"
              onClick={() => handleProductNavigate('hardware')}
            />
          </div>
        </div>
        <div className="Main_info_section5">
          <div
            data-aos="fade"
            data-aos-easing="ease-out"
            data-aos-duration="1300"
            className="Main_info_section5_contents_title"
          >
            Partners with us
          </div>
          <div className="Main__info_section5_img_contents">
            <div className="logo-slider">
              <div className="logo-track">
                {[...logos, ...logos].map((logo, idx) => (
                  <div key={idx} className="logo-item">
                    <img src={logo.src} alt={logo.name} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="Main_info_section6">
          <img src={mainbanner2} />
          <div className="Main_info_section6_contents">
            <div className="Main_info_section6_contents_title">{t('section6.des')}</div>
            <NavLink
              to="/Contact"
              className={({ isActive }) =>
                isActive ? 'Main_info_section6_contents_sub' : 'Main_info_section6_contents_sub'
              }
            >
              {t('CONTACT')}
            </NavLink>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Main;
